<template>
  <div class="nose nose--no-height" :style="{ flexDirection: direction }" :class="{ 'nose--disabled': disabled }">
    <div :style="{ backgroundColor: `${bgColor}` }" class="nose__inner" :class="{ 'nose__inner--nose': svg }">
      <div class="header">
        <h3>{{ num }} {{ title }}</h3>
      </div>
      <div class="description" v-html="description"></div>
      <div class="content">
        <div v-for="(item, index) in items" :key="`unit-${index}`" class="item elevation-2 results-display">
          <div class="item__text">
            <p>{{ item.title }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="nose__peak" v-if="bgSrc">
      <img :src="bgSrc" alt="" class="nose__peak-image" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "ResultsCard",
  data() {
    return {
      items: this.value,
      item: {},
      currIndex: null,
      refs: null,
      fields: [],
      editMode: false,
      editIndex: null,
      deleteMode: false,
      deleteId: null,
      dialog: false,
    };
  },
  props: {
    value: Array,
    name: String,
    title: String,
    description: String,
    num: String,
    label: String,
    color: String,
    limit: {
      type: Number,
      default: 3,
    },
    svg: {
      type: String,
      default: "",
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    bgMode: {
      type: Boolean,
      default: false,
    },
    formAbove: {
      type: Boolean,
      default: true,
    },
    results: {
      type: Object,
      default: () => { },
    },
    bgColor: {
      type: String,
    },
  },

  computed: {
    direction() {
      return this.reverse ? "row-reverse" : "row";
    },
    bgSrc() {
      if (this.svg) {
        return require(`@/assets/${this.svg}`);
      } else {
        return false;
      }
    },
    maxItems() {
      if (this.limit) {
        return (this.items && this.items.length) >= this.limit ? true : false;
      } else {
        return false;
      }
    },
  },
  mounted() {
    if (this.collection) {
      this.getRefs();
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.nose {
  min-height: 80vh;
  // height: 80vh;
  height: 100%;
  overflow: visible;
  display: flex;

  &--disabled {
    opacity: 0.4;
    pointer-events: none;
  }

  &__peak {
    height: 100%;
    width: 10%;
    position: relative;

    &-image {
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
    }
  }

  &__inner {
    width: 100%;
    min-height: 80vh;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-right: 1rem;

    &--nose {
      width: 90%;
      padding-right: 0rem;
    }
  }

  &--no-height {
    min-height: auto;

    .nose__inner {
      min-height: auto;
    }
  }

  .header {
    width: 100%;
    padding: 1rem 0 0 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      border-bottom: 2px solid white;
    }
  }

  .description {
    padding: 0.25rem 1rem 0 1rem;
  }

  .content {
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 1rem;
    padding-bottom: 1rem;
    width: 100%;
    min-height: 50px;

    .inner {
      width: 90%;

      .item {
        padding: 0;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin: 0.75rem 0;
        border-radius: 0px;
        color: black;
        width: 100%;
        flex-direction: column;
        background: white;

        p {
          text-align: left;
          padding: 0.5rem 0.5rem 0.5rem 0.5rem;
          font-size: 1rem;
          line-height: 1.5rem;
          margin: 0;
          font-weight: 400;
        }

        .icons {
          width: 100%;
          padding: 0.2rem;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin: 0.5rem 0 0 0;
          background: rgba(0, 0, 0, 0.2);
          pointer-events: auto;

          span {
            cursor: pointer;
          }
        }

        &__edit {
          text-align: left;
          font-size: 1rem;
          line-height: 0.9rem;
          margin: 0;
          padding: 0.5rem 0.5rem 0.5rem 0.5rem;
          font-weight: 400;
          width: 100%;
          color: black;
        }

        &__text {
          width: 100%;
        }
      }
    }

    &__item {
      min-height: 400px;
      border-radius: 50%;
      align-items: center;
      justify-content: center;
      display: flex;
      width: 100%;
    }
  }
}

.results-display {
  display: block;
  width: 80%;
  background: rgb(252, 252, 252);
  color: black;
  text-align: left;
  padding: 0.4rem 1rem;
  margin: 0.5rem auto;
  border-radius: 4px;

  p {
    margin: 0;
  }
}
</style>
